import * as Yup from 'yup';

export const validationSchema = Yup.object({
  eventDateTime: Yup.date()
    .typeError('Please enter a valid event date and time')
    .nullable()
    .required('Event date and time is required'),
  eventCategory: Yup.string().required('Event category is required'),
  phoneNumber: Yup.string().required('Home phone is a required field'),
  eventName: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Event name is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  deliveryType: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Delivery type is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  ticketProvider: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Ticket provider is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  channel: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Channel is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  seatDetails: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Seat details are required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  bookingReference: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Booking reference is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
  venueName: Yup.string().when('buttonAction', {
    is: 'Confirmed',
    then: (schema) => schema.required('Venue name is required for confirmation'),
    otherwise: (schema) => schema.nullable(),
  }),
});

export const initialValues = {
  channel: '',
  subStatus: '',
  ticketProvider: '',
  deliveryType: '',
  cancellationReason: '',
  isEligibleForCashback: '',
  isLastCashbackBooking: '',
  isUseMailingAddress: true,
  phoneNumber: '',
  mobileNumber: '',
  alternatePhoneNumber: '',
  alternateEmail: '',
  comments: '',
  eventName: '',
  venueName: '',
  eventDateTime: null,
  eventCategory: '',
  bookingDate: null,
  seatDetails: '',
  bookingReference: '',
  postageFee: '',
  totalBookingFee: '',
  totalActualPrice: '',
  extraCashback: '',
  totalCashback: '',
  currency: '',
  totalPriceAfterCashback: '',
  extraCashbackPercentage: '',
  buttonAction: '',
  deliveryName: '',
  addressLineOne: '',
  addressLineTwo: '',
  addressLineThree: '',
  city: '',
  postalCode: '',
  county: '',
  country: '',
  state: '',
};
